<template>
  
        <ul  class="navbar-nav h-100 pt-2 mr-3" v-if="categories&&categories.length">
          <li
            v-for="item in categories"
            :key="item.id"
            :class="{ 'has-children': item.children.length != 0 }"
            class="nav-item text-center fontsize-small"
          >
            
            <router-link
              class="nav-link d-inline-block weight-bold"
              :to="`/products/category/${item.en_title}`">
              {{ item.title }}
              <span v-if="item.children.length != 0">
                <svg
                  width="11"
                  height="11"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M19 8.5L12 15.5L5 8.5"
                    stroke="#444"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </span>
            </router-link>
            <ul
              v-if="item.children.length != 0"
              class=" dropdown-menu-hover list-unstyled justify-content-center align-items-center bgWhite">
              <li  v-for="childMenu in item.children"  :class="{ 'has-child-children': childMenu.children.length != 0 }"
                   :key="childMenu.id"  class="nav-item">
               
                <router-link
                  class="nav-link"
                  :to="`/products/category/${childMenu.en_title}`">{{ childMenu.title }}
                  <span v-if="childMenu.children.length != 0">
                    <i
                      style="position: relative; top: 2px"
                      class="fa fa-angle-left"
                    ></i>
                  </span>
                </router-link>
                <ul
                  v-if="childMenu.children.length != 0"
                  class="
                    dropdown-child-menu-hover list-unstyled
                    justify-content-center align-items-center bgWhite">
                  <li
                    :class="{ 'has-child-children': childrenMenu.children.length != 0 }"
                    v-for="childrenMenu in childMenu.children"
                    :key="childrenMenu.id"
                    class="nav-item">
                  
                    <router-link 
                      class="nav-link childMenu"
                      :to="`/products/category/${childrenMenu.en_title}`"
                      >{{ childrenMenu.title }}
                      <span v-if="childrenMenu.children.length != 0">
                        <i
                            style="position: relative; top: 2px"
                            class="fa fa-angle-left"
                        ></i>
                      </span>
                    </router-link>
          <!-- THIRD MENU -->
                    <ul
                        v-if="childrenMenu.children.length != 0"
                        class="
                    dropdown-child-child-menu-hover list-unstyled
                    justify-content-center align-items-center bgWhite">
                      <li v-for="childrenChildMenu in childrenMenu.children"
                          :key="childrenChildMenu.id"
                          class="nav-item">
                        
                        <router-link 
                            class="nav-link childMenu"
                            :to="`/products/category/${childrenChildMenu.en_title}`"
                        >{{ childrenChildMenu.title }}
                        </router-link>
                      </li>
                    </ul>
    
                  </li>
                </ul>
              </li>
            </ul>
          </li>
        </ul>
        
  </template>
  
  <script>
  import {BRow, BSkeleton} from 'bootstrap-vue'
  
  export default {
    name: "Nav",
    components: {
      BRow, BSkeleton
    },
    computed: {
      
      status() {
        return this.$store.getters["front/getHomeDataStatus"];
      },
      categories() {
        
        if (this.$store.getters["front/getHomeData"] == null) {
          return null;
        } else {
          return this.$store.getters["front/getHomeData"].categories
         
        }
      },
    },
   
  };
  </script>
  
  <style scoped>
  .childMenu {
    color: #666;
  }
  #menuSkelton {
    display: flex;
    justify-content: space-around;
    /*width: 300px;*/
  }
  
  
  .navbar-nav {
    gap: 20px;
  }
  .nav-item {
    position: relative;
  }
  .main-menu.navbar-expand > .navbar-nav > .nav-item:hover:before {
    content: '';
    height: 2px;
    width: 100%;
    background: var(--color-theme3);
    position: absolute;
    bottom: 4px;
  }
  .bgWhite{
    background-color: white;
  }
  
  @media screen and (max-width : 1450px) {
    .navbar-nav{
      gap: 3px;
    }
  }
  </style>
  